<template>
  <div>
    <!-- Sticky Rotated Feedback Button -->
    <div
      class="uk-position-fixed"
      style="
        top: 80%;
        right: 0;
        transform: translateY(-50%) rotate(-90deg);
        transform-origin: right bottom;
        z-index: 1000;
      "
    >
      <button
        class="uk-button feedback-button"
        uk-toggle="target: #feedback-modal"
      >
        Feedback
      </button>
    </div>

    <!-- Modal with Google Form -->
    <div id="feedback-modal" uk-modal>
      <div class="uk-modal-dialog uk-modal-body uk-width-3-4 uk-width-1-2@m">
        <button class="uk-modal-close-default" type="button" uk-close></button>
        <h4 class="uk-modal-title">We’d love your feedback</h4>
        <p class="uk-text-small">
          Please take a minute to tell us what you thought about your test results.
        </p>

        <iframe
          :src="formUrl"
          width="100%"
          height="500"
          frameborder="0"
          marginheight="0"
          marginwidth="0"
        >
          Loading…
        </iframe>

        <p class="uk-text-meta uk-text-center uk-margin-small-top">
          Having trouble? 
          <a :href="formUrl" target="_blank" rel="noopener">Open the survey in a new tab</a>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeedbackButton',
  data() {
    return {
      formUrl:
        'https://docs.google.com/forms/d/e/1FAIpQLSdda3LDQQHM9yL4_UxlqoFHDHi4rPcoKZCT8IQ1uXDW4TN4TQ/viewform?embedded=true',
    };
  },
};
</script>